import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSparkle3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sparkle-3, ai, star, magic"><path d="M12.925 2.75H11.075L8.7625 8.7625L2.75 11.075V12.925L8.7625 15.2375L11.075 21.25H12.925L15.2375 15.2375L21.25 12.925V11.075L15.2375 8.7625L12.925 2.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconSparkle3;
